<script>
	import Select, { Option } from "@smui/select";
	import { Icon } from "@smui/common";

	import { colorthemes } from "../stores";

	export let selected;
	export let modified;
	export let original;
	export let noSelection = false;
	export let noSelectionLabel = "";
	export let label = "Select color theme";

	$: modified = selected != original; // using != (without second =) on purpose because null === undefined is false and null == undefined is true which is what we need
</script>

<div class="edit-colortheme">
	<Select bind:value={selected} {label} key={(value) => `${value == null ? noSelectionLabel : value}`}>
		{#if noSelection}
			<Option value={null}>{noSelectionLabel}</Option>
		{/if}
		{#each $colorthemes.sort((a, b) => b.free - a.free) as ct (ct.colortheme_id)}
			<Option value={ct.colortheme_id}>
				{ct.name}
			</Option>
		{/each}
	</Select>
</div>

<style lang="scss">
	.edit-colortheme {
		:global(.mdc-select) {
			width: 100%;
			max-width: 400px;
		}

		:global(.mdc-select__menu) {
			max-height: 400px !important;
		}
	}
</style>
